module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-0119121029917d2c954b52c12b2724d3.png";